import styles from './paper.less?modules';
import classnames from 'classnames';
export const Paper = (props) => {
  return (
    <div className={classnames(styles.paper, styles[props.className])}>
      {props.children}
    </div>
  );
};
